<template>
  <component :is="component"></component>
</template>

<script>
import KeyIndicatorHk from './KeyIndicatorHk.vue'
import KeyIndicatorUs from './KeyIndicatorUs.vue'
import KeyIndicatorHs from './KeyIndicatorHs.vue'
const components = {
  hk: KeyIndicatorHk,
  hs: KeyIndicatorHs,
  us: KeyIndicatorUs
}
export default {
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    },
    component() {
      return components[this.market]
    }
  }
}
</script>
